import { render, staticRenderFns } from "./choosecustomer.vue?vue&type=template&id=1cf44f6c"
import script from "./choosecustomer.vue?vue&type=script&lang=js"
export * from "./choosecustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports